import {PageMap} from '@wix/wixstores-client-core/dist/es/src/constants';
import {BLOCKS_PRODUCT_PAGE_APP_DEF_ID, FedopsInteractions} from '../constants';
import {ComponentClientSpecMapEntry, EditorSDK} from '@wix/platform-editor-sdk';
import {getEcomPages} from './pages';
import {APP_DEFINITION_ID} from '@wix/wixstores-client-core/dist/src/constants';

async function getProductPageRef(sdk: EditorSDK) {
  const ecomPages = await getEcomPages(sdk);
  const productPage = ecomPages.find((page) => page.tpaPageId?.startsWith(PageMap.PRODUCT));
  return sdk.tpa.getPageRefByTPAPageId('', {tpaPageId: productPage?.tpaPageId});
}

export async function installBlocksProductPage(sdk: EditorSDK, fedopsLogger: Record<string, any>) {
  fedopsLogger?.interactionStarted?.(FedopsInteractions.BlocksProductPageAppInstallation);
  await sdk.document.tpa.add.application('', {
    appDefinitionId: BLOCKS_PRODUCT_PAGE_APP_DEF_ID,
  });
  fedopsLogger?.interactionEnded?.(FedopsInteractions.BlocksProductPageAppInstallation);
}

export async function addBlocksProductPageToExistingSite(sdk: EditorSDK, fedopsLogger: Record<string, any>) {
  const productPageRef = await getProductPageRef(sdk);
  await sdk.pages.remove('', {pageRef: productPageRef, shouldShowEditorRemovePanel: false});
  await installBlocksProductPage(sdk, fedopsLogger);
  return sdk.application.reloadManifest();
}

export async function getComponent(sdk: EditorSDK, widgetId: string) {
  const allComponents = await sdk.document.tpa.app.getAllComps('', APP_DEFINITION_ID);
  return allComponents.find((comp) => comp.widgetId === widgetId);
}

export async function getCompRef(sdk: EditorSDK, component: ComponentClientSpecMapEntry) {
  return sdk.document.components.getById('', {id: component.id});
}
